<template>
  <div class="position_bg">
    <img src="../assets/position_date.png" style="height: 100px"/>
    <div class="text">
      <template v-if="isEnterpriseChildUser">
        {{ $t('position.date.child') }}
        <span class="over_date">{{ $t('sys.talk.overdue') }}</span>,
        {{ $t('position.date.create') }}
      </template>
      <template v-else>
        {{ $t('position.date.child') }}
        <span class="over_date">{{ $t('sys.talk.overdue') }}</span>,
        <span style="color: #0a84ff;cursor: pointer" @click="handleClickToBuy">{{ $t('position.date.xf') }}</span>
      </template>
    </div>
  </div>
</template>


<script setup>
import {computed} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";

const store = useStore()
const router = useRouter()
const route = useRoute()

const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
const isEnterpriseChildUser = computed(() => store.getters["user/isEnterpriseChildUser"])


const handleClickToBuy = async () => {
  // router.push(`/personal/station?teamId=${route.query.teamId}`)
  console.log(route.query.workPositionId, typeof route.query.workPositionId, 'route.query.workPositionId')
  if (route.query.workPositionId !== 'null') {
    const arr = route.query.workPositionId && [route.query.workPositionId].join(',')
    await router.push(`/personal/buystorage?Renewal=1&arr=${arr}&indexId=1&productSort=1&type=2`)
  }
}
</script>


<style lang="less" scoped>

.position_bg {
  width: 100%;
  height: 100%;
  background: #F5F5F5;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .text {
    margin-top: 30px;

    .over_date {
      color: #d53032;
    }
  }
}
</style>